module.exports = __webpack_public_path__ + "img/logo_made.c42393d2.png";